import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function LoginPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ emailOrPhone: '', password: '' });
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await axios.post('/api/users/login', form);
      const { token, role } = res.data;

      localStorage.setItem('token', token);

      // ✅ Role-based redirect
      if (role === 'admin') navigate('/admin/access');
      else if (role === 'provider') navigate('/dashboard');
      else navigate('/my-bookings');
    } catch (err) {
      setError('Login failed. Check credentials.');
    }
  };

  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold mb-4">Login</h2>
      <form className="max-w-md mx-auto space-y-4" onSubmit={handleLogin}>
        <input
          className="w-full border p-2 rounded"
          placeholder="Email or Phone"
          value={form.emailOrPhone}
          onChange={(e) => setForm({ ...form, emailOrPhone: e.target.value })}
        />
        <input
          className="w-full border p-2 rounded"
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
        />
        <button className="w-full bg-blue-500 text-white p-2 rounded">Login</button>
        {error && <p className="text-red-500 text-sm">{error}</p>}
      </form>
    </div>
  );
}

export default LoginPage;
